import React , {Component} from 'react';
import { PnkConnect } from '../../pnk-react/pnk-miniredux';
import PatnerDetailsPage from './patnershipDetails';



class patnerDetails extends Component{
    // constructor(){
    //     super()
    // }

    render(){
        return(
            <div>
            <PatnerDetailsPage {...this.props}/>
            </div>
        )
    }
}

export const PartnerDetails = PnkConnect(patnerDetails , '');